import React from 'react'
import './ProgressCount.css'
import {formatNumber} from "../../shared/Utility";

const progressCount = props => {

  const style = {
    width: (props.currentStats.hasOwnProperty('ratioPc') ? props.currentStats.ratioPc : 100) + '%'
  };

  return (
    <div>
      <strong className="text-bold">{formatNumber(props.currentStats.count)}</strong>&nbsp;&nbsp;&nbsp;{props.currentStats.title}
      <span className="pull-right text-success text-bold">
        <strong>{(props.currentStats.hasOwnProperty('ratioPc') ? props.currentStats.ratioPc + '%' : '')}</strong>
        {/*<i className="md md-trending-up"/>*/}
      </span>
      <div className="progress progress-hairline">
        <div className={"progress-bar progress-bar-" + props.currentStats.progressBarClass} style={style}/>
      </div>
    </div>
  )
};

export default progressCount;
